import { staticPartners } from '@/content/partners'
import type { Database } from '@/types/database'

export type Partner = Database['public']['Tables']['partners']['Row']

interface State {
  partners: Partner[]
  featuredPartner: Partner | null
  loading: boolean
  error: string | null
}

const activePartners = staticPartners
  .filter((p) => p.active)
  .sort(
    (a, b) =>
      Number(b.featured) - Number(a.featured) ||
      (a.display_order ?? Infinity) - (b.display_order ?? Infinity),
  )

/**
 * Founding partners, served from a static list so the section renders
 * instantly and stays up even if the Supabase project idles/pauses. Keeps the
 * async-looking interface so Partners.tsx is unchanged.
 */
export function usePartners(): State {
  return {
    partners: activePartners,
    featuredPartner: activePartners.find((p) => p.featured) ?? null,
    loading: false,
    error: null,
  }
}
